module.exports = __webpack_public_path__ + "static/Consultation2-acf0ef94f8e88e0d8860b8698fddcbfa.jpg";